import { render, staticRenderFns } from "./DetailProductVessel.vue?vue&type=template&id=70c3a824&"
import script from "./DetailProductVessel.vue?vue&type=script&lang=js&"
export * from "./DetailProductVessel.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductVessel.vue?vue&type=style&index=0&id=70c3a824&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports